import { Routes, Route, Navigate } from 'react-router';
import { lazy, Suspense } from 'react';
import Redesign from '@/pages/Redesign';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { LoadingSpinner } from '@/components/LoadingSpinner';

const Index = lazy(() => import('@/pages/Index'));
const Accessibility = lazy(() => import('@/pages/Accessibility'));
const Privacy = lazy(() => import('@/pages/Privacy'));
const Admin = lazy(() => import('@/pages/Admin'));
const AdminPreview = lazy(() => import('@/pages/AdminPreview'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const AccessibilityToolbar = lazy(() => import('@/components/AccessibilityToolbar'));

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingSpinner fullPage text="טוען דף..." />}>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Redesign />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/preview" element={<AdminPreview />} />
            <Route path="/redesign" element={<Navigate to="/" replace />} />
            <Route path="/classic" element={<Index />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
      </Suspense>

      <Suspense fallback={null}>
        <AccessibilityToolbar />
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
